import {
  ContipleAntdConfigProvider,
  App as ContipleApp,
} from '@contiple/antd-ds';
import { ThemeProvider } from 'next-themes';
import { Loading } from './components';
import { PermissionProvider } from './contexts/permission/PermissionProvider';
import { ToastProvider } from './contexts/toast/ToastProvider';
import { AppRouter } from './router';
import { useLanguageStore, useThemeStore, useUserStore } from './store';
import { useComponentSizeStore } from './store/componentSizeStore';
import { isMobileOrTablet } from './utils';
import UnsupportedDevice from './views/error/UnsupportedDevice';

const App = () => {
  const { theme } = useThemeStore();
  const { language } = useLanguageStore();
  const { componentSize } = useComponentSizeStore();
  const { user } = useUserStore();

  if (!user) {
    return <Loading />;
  }

  return (
    <ThemeProvider attribute="class" defaultTheme={theme}>
      <ContipleAntdConfigProvider
        theme={theme}
        language={language}
        size={componentSize}>
        <ContipleApp>
          <PermissionProvider>
            <ToastProvider>
              {isMobileOrTablet() ? <UnsupportedDevice /> : <AppRouter />}
            </ToastProvider>
          </PermissionProvider>
        </ContipleApp>
      </ContipleAntdConfigProvider>
    </ThemeProvider>
  );
};

export default App;
